import { ActiveRiskType, TransactionCloseType, TransactionData, TransactionReason } from '../../../../domain/stream/transaction/TransactionDomains';

export interface LocalCaseMutation {
  status: TransactionReason;
  code: string;
}

export interface TransactionApiUpdateDetector {
  shouldNotify(
    local: TransactionData | undefined,
    remote: TransactionData,
    riskType: ActiveRiskType,
    localMutation: LocalCaseMutation | undefined,
  ): boolean;
  matchesLocalMutation(remote: TransactionData, riskType: ActiveRiskType, localMutation: LocalCaseMutation | undefined): boolean;
  revision(transaction: TransactionData, riskType: ActiveRiskType): string;
}

export class DefaultTransactionApiUpdateDetector implements TransactionApiUpdateDetector {
  public shouldNotify(
    local: TransactionData | undefined,
    remote: TransactionData,
    riskType: ActiveRiskType,
    localMutation: LocalCaseMutation | undefined,
  ): boolean {
    if (local == undefined) {
      return false;
    }
    if (this.readCloseType(remote, riskType) !== 'API') {
      return false;
    }
    if (this.matchesLocalMutation(remote, riskType, localMutation)) {
      return false;
    }
    return this.revision(local, riskType) !== this.revision(remote, riskType);
  }

  public matchesLocalMutation(remote: TransactionData, riskType: ActiveRiskType, localMutation: LocalCaseMutation | undefined): boolean {
    if (localMutation == undefined) {
      return false;
    }
    const remoteStatus: TransactionReason | undefined = remote.result[riskType]?.status;
    const remoteCode: string = remote.result[riskType]?.metadata?.code ?? '';
    return remoteStatus === localMutation.status && remoteCode === localMutation.code;
  }

  public revision(transaction: TransactionData, riskType: ActiveRiskType): string {
    const status: TransactionReason | undefined = transaction.result[riskType]?.status;
    const closeType: TransactionCloseType | undefined = this.readCloseType(transaction, riskType);
    const code: string = transaction.result[riskType]?.metadata?.code ?? '';
    const endDate: number | undefined = transaction.result[riskType]?.metadata?.review?.endDate;
    return `${status ?? ''}|${closeType ?? ''}|${code}|${endDate ?? ''}`;
  }

  private readCloseType(transaction: TransactionData, riskType: ActiveRiskType): TransactionCloseType | undefined {
    return transaction.result[riskType]?.metadata?.closeType;
  }
}
